import { Settings } from '@ais-ui/websockets';

export const areSourceIdentifiersShowOnStartUp = (
  settings: Settings
): boolean => {
  return (
    settings?.['ribbonPlugin.settings']?.coverage_source_identifiers ?? false
  );
};
